import React from "react";
import { Dialog, DialogContent, DialogActions, Box, Typography, Button } from "@mui/material";
import { CheckCircle } from "@mui/icons-material";

// Shown right after a shipment is successfully created — previously the
// create dialog just closed silently with no confirmation at all. Offers
// the two things an admin/customer actually wants next: log another one
// right away (common when entering several orders back to back), or just
// close and go back to the list.
const ShipmentCreatedDialog = ({ open, trackingNumber, onCreateAnother, onClose }) => (
  <Dialog open={open} onClose={onClose} maxWidth="xs" fullWidth>
    <DialogContent sx={{ textAlign: "center", pt: 4, pb: 2 }}>
      <CheckCircle sx={{ fontSize: 56, color: "success.main", mb: 1.5 }} />
      <Typography variant="h6" fontWeight={700}>
        Shipment Created
      </Typography>
      {trackingNumber && (
        <Typography variant="body2" color="text.secondary" sx={{ mt: 0.5 }}>
          Shipment #: <Box component="span" sx={{ fontFamily: "monospace", fontWeight: 700 }}>{trackingNumber}</Box>
        </Typography>
      )}
    </DialogContent>
    <DialogActions sx={{ px: 3, pb: 3, gap: 1 }}>
      <Button onClick={onClose} variant="outlined" fullWidth>
        Close
      </Button>
      <Button onClick={onCreateAnother} variant="contained" fullWidth>
        Create Another
      </Button>
    </DialogActions>
  </Dialog>
);

export default ShipmentCreatedDialog;
